module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Up-right-fcad18fdb369aec75aac8e3d33ee4332.svg";